import { Text as PixiText } from 'pixi.js';
import type { TextStyle } from 'pixi.js';

export default class Text extends PixiText {
  constructor(text: string, style?: Partial<TextStyle>) {
    super({ text, style });
  }
}
